<div class="ig-modal ig-set-approved">
    <h2 mat-dialog-title>Events and places default Approved</h2>

    <mat-dialog-content class="dialog-content">
        <div [formGroup]="hubApprovedForm" class="text-left">
            <b>Events Default Approved</b>
            <div class="group">
                <mat-radio-group class="radio-group" [(ngModel)]="eventApproved"
                    [formControl]="hubApprovedForm.get('eventApproved')">
                    <mat-radio-button [value]="true">
                        Approved
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                        Unapproved
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <b>Places Default Approved</b>
            <div class="group">
                <mat-radio-group class="radio-group" [(ngModel)]="placeApproved"
                    [formControl]="hubApprovedForm.get('placeApproved')">
                    <mat-radio-button [value]="true">
                        Approved
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                        Unapproved
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <b>Jobs Default Approved</b>
            <div class="group">
                <mat-radio-group class="radio-group" [(ngModel)]="jobApproved"
                    [formControl]="hubApprovedForm.get('jobApproved')">
                    <mat-radio-button [value]="true">
                        Approved
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                        UnApproved
                    </mat-radio-button>
                </mat-radio-group>
            </div>

        </div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button class="mat-raised-button" (click)="close()">Close</button>
        <button class="mat-raised-button mat-primary" (click)="save()">Save</button>
    </mat-dialog-actions>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/set.approved/set.approved.component.html